import { render, staticRenderFns } from "./list.vue?vue&type=template&id=23737c16&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23737c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23737c16')) {
      api.createRecord('23737c16', component.options)
    } else {
      api.reload('23737c16', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=23737c16&scoped=true", function () {
      api.rerender('23737c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/reunionDinnerManagement/chefLabelManagement/list.vue"
export default component.exports